var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.06506 1.4403C4.1057 1.39956 4.15397 1.36723 4.20713 1.34518C4.26028 1.32312 4.31726 1.31177 4.37481 1.31177C4.43235 1.31177 4.48933 1.32312 4.54248 1.34518C4.59564 1.36723 4.64392 1.39956 4.68456 1.4403L9.93455 6.6903C9.9753 6.73094 10.0076 6.77922 10.0297 6.83237C10.0517 6.88552 10.0631 6.9425 10.0631 7.00005C10.0631 7.0576 10.0517 7.11458 10.0297 7.16773C10.0076 7.22088 9.9753 7.26916 9.93455 7.3098L4.68456 12.5598C4.6024 12.642 4.49098 12.6881 4.37481 12.6881C4.25863 12.6881 4.14721 12.642 4.06506 12.5598C3.9829 12.4776 3.93675 12.3662 3.93675 12.25C3.93675 12.1339 3.9829 12.0225 4.06506 11.9403L9.00618 7.00005L4.06506 2.0598C4.02431 2.01916 3.99199 1.97088 3.96993 1.91773C3.94788 1.86458 3.93652 1.8076 3.93652 1.75005C3.93652 1.6925 3.94788 1.63552 3.96993 1.58237C3.99199 1.52922 4.02431 1.48094 4.06506 1.4403Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.525b2bd3f6dcc568259312e3e19bd11c.svg";
export { ForwardRef as ReactComponent };